import { Fragment, memo, useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';
import { RetrievedIdCard } from 'front-office/view-models/retrieve-id-card/retrieved-id-card';
import CardRow from './table-row';

export interface TableIdCardComponentProps {
  retrievedIdCards: Array<RetrievedIdCard>;
  onTrashPress: (card: RetrievedIdCard) => void;
}

const TableIdCardComponent = ({ retrievedIdCards, onTrashPress }: TableIdCardComponentProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const rowsPerPageOptions = [5, 10, 20, 50];

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <TableContainer>
        <Table sx={{ minWidth: 900 }} size="medium" stickyHeader aria-label="lista soggetti">
          <TableHead>
            <TableRow>
              <PmiHeadTableCell>XML</PmiHeadTableCell>
              <PmiHeadTableCell>Azioni</PmiHeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(retrievedIdCards || []).slice(startIndex, endIndex).map((card) => (
              <CardRow key={card.code} retrievedCard={card} onTrashPress={onTrashPress} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        labelRowsPerPage="Righe per pagina:"
        count={retrievedIdCards.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event: unknown, newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </Fragment>
  );
};

TableIdCardComponent.displayName = 'Table id card component';

const TableIdCard = memo(TableIdCardComponent);

export default TableIdCard;
